import { render, staticRenderFns } from "./edit-session-modal.vue?vue&type=template&id=22a2cac7&scoped=true"
import script from "./edit-session-modal.vue?vue&type=script&lang=js"
export * from "./edit-session-modal.vue?vue&type=script&lang=js"
import style0 from "./edit-session-modal.vue?vue&type=style&index=0&id=22a2cac7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a2cac7",
  null
  
)

export default component.exports